export const ASSETS_CDN = process.env.REACT_APP_ASSETS_CDN;
export const ASSETS_PREFIX_REGEXP = /^asset-image:/g;
